import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {withTranslation} from 'react-i18next';
import {SortableContainer, SortableElement} from 'react-sortable-hoc';
import Modal from 'react-modal';
import style from './Basket.css';
import classNames from 'classnames';
import CssUtility from '../../utilities/CssUtility'
import Draggable from 'react-draggable';

class ListWrapper extends Component {

	constructor({items}) {
		super()
		this.state = {
			isSorting: false
		};
	}

	static propTypes = {
		items: PropTypes.array,
		className: PropTypes.string,
		itemClass: PropTypes.string,
		width: PropTypes.number,
		height: PropTypes.number,
		onSortStart: PropTypes.func,
		onSortEnd: PropTypes.func,
		component: PropTypes.func,
		shouldUseDragHandle: PropTypes.bool
	}

	static defaultProps = {
		className: classNames(style.list, style.stylizedList),
		itemClass: classNames(style.item, style.stylizedItem)
	}

	onSortStart = (node, event) => {

		// We want to stop bubbling the event
		event.stopPropagation()
		event.preventDefault()

		let {onSortStart} = this.props;
		this.setState({isSorting: true})

		if (onSortStart) {
			onSortStart(this.refs.component)
		}
	}

	onSortEnd = ({oldIndex, newIndex}) => {
		let {onSortEnd} = this.props;

		// this.props.itemMove
		this.setState({
			isSorting: false
		})

		this.props.movePositionInBasket(oldIndex, newIndex)

		if (onSortEnd) {
			onSortEnd(this.refs.component)
		}
	}

  componentDidMount() {
    const handler = e => this.setState({matches: e.matches});
    window.matchMedia("(min-width: 768px)").addEventListener('change', handler);
  }

	render() {
		const Component = this.props.component;
		const {isSorting} = this.state;
		const {items} = this.props;
		const props = {
			isSorting,
			items,
			onSortEnd: this.onSortEnd,
			onSortStart: this.onSortStart,
			ref: "component",
			useDragHandle: this.props.shouldUseDragHandle
		}

		return <Component {...this.props} {...props} />
	}
}

/**
 * Have the title of the CallForApplicationItem displayed on two lines
 *
 * @param {string} value
 * @returns {string}
 */
const formatTitle = (value) => {
	let formattedValue = <span>{value}</span>;
	if (value) {
		const titleParts = value.split(' – ')
		if (titleParts.length > 1) {
			formattedValue = <span>{titleParts[0]} <br/> {titleParts[1]}</span>;
		}
	}
	return formattedValue
}

/**
 *
 */
const SortableList = SortableContainer(({className, items, itemClass, sortingIndex, shouldUseDragHandle, sortableHandlers, removeFromBasket}) => {
	return (
		<div className={className} {...sortableHandlers}>
			{items.map((value, index) => {
					return (
						<Item
							key={`item-${value.__identity}`}
							className={itemClass}
							sortingIndex={sortingIndex}
							index={index}
							position={index + 1}
							value={value}
							height={40}
							removeFromBasket={removeFromBasket}
							shouldUseDragHandle={shouldUseDragHandle}
						/>
					)
				}
			)}
		</div>
	)
})

/**
 * @param pos
 * @returns {string}
 */
const formatStars = (pos) => {
	let stars = '';
	let i = 0;

  // Can be set in ApplicationForm Node, defaults to 5 if not set
  let maximumNumberOfItemsInBasket = parseInt(AblCh.maximumNumberOfItemsInBasket);
  let numOfStars = (maximumNumberOfItemsInBasket > 0 ? maximumNumberOfItemsInBasket : 5) - (pos - 1)

	while (i < numOfStars) {
		stars = stars + '♥︎';
		i++;
	}
	return stars;
};

/**
 *
 */
const Item = SortableElement((props) => {
	return (
		<div className="basket__item">
			<button className="btn btn-secondary btn-sm" onClick={() => props.removeFromBasket(props.value)} onTouchStart={() => props.removeFromBasket(props.value)}>
				<i className="abl-icon-cancel"/>
			</button>
			<div className="myrating">
				{formatStars(props.position)}
			</div>
			<div className="basket__item-position">
				Ausschreibung Nr. {props.value.position}
			</div>
			<div className="title">
				{formatTitle(props.value.title)}<br />
				{props.value.realEstateObject.floor}
			</div>
		</div>
	)
})

// Decorate the class.
@withTranslation()
export default class Basket extends Component {

	/**
	 * @param {object} props
	 */
	constructor(props) {
		super(props)

		this.state = {
			modal: {
				isShown: false,
				isSubmitting: false
			}
		}

		this.redirect = this.redirect.bind(this)
		this.hideModal = this.hideModal.bind(this)
		this.showModal = this.showModal.bind(this)
		this.applyOnline = this.applyOnline.bind(this)
	}

  componentDidMount() {
    window.addEventListener('resize', this.disableDrag);
  }

  /**
	 * @returns void
	 */
	hideModal() {
		const newState = this.state.modal
		newState.isShown = false
		this.setState({modal: newState})
	}

	/**
	 * @returns void
	 */
	showModal() {
		const newState = this.state.modal
		newState.isShown = true
		this.setState({modal: newState})
	}

	redirect() {
		const newState = this.state.modal
		newState.isSubmitting = true
		this.setState({modal: newState})
		window.location = $('[data-application-form-uri]').first().data('application-form-uri')
	}

	/**
	 * Redirect to the application form
	 */
	applyOnline() {

		if (this.props.items.length === 1) {
			this.showModal()
		} else {
			this.redirect()
		}
	}

	/**
	 * @param {Event} e
	 * @returns {boolean}
	 */
	shouldCancelStart(e) {
		// Prevent sorting from being triggered if target is input or button
		if (['input', 'button', 'i'].indexOf(e.target.tagName.toLowerCase()) !== -1) {
			return true; // Return true to cancel sorting
		}
	}

  // we stop draggable capabilities for < md
  disableDrag() {
		if ($(window).width() < 992) {
      Draggable.disabled = true;
			return true;
		}
    else {
      Draggable.disabled = false;
      return false;
    }
	}

  showPageTopButton() {
    const menuMetaNavi = document.querySelectorAll('#menu-meta ul');
    const pageTopButton = document.createElement('li');
    pageTopButton.id = 'pageTopButton';
    pageTopButton.style.marginTop = '-12px';
    pageTopButton.innerHTML = '<a href="#residentialMarket__basket"><i class="abl-icon-haus-smiley faa-pulse faa-slow animated icon-3x"></i></a>';
    if( document.getElementById('pageTopButton') === null ) {
      menuMetaNavi[0].prepend(pageTopButton);
    }
  }

	/**
	 * @returns {JSX.Element}
	 */
	render() {
		const {t} = this.props;
		const maximumNumberOfItemsInBasket = AblCh.maximumNumberOfItemsInBasket;
		this.showPageTopButton();

    return (
			<div>
        <div className="basket clearfix" id="residentialMarket__basket">
						<div>
							<i className="abl-icon-haus-smiley icon-3x hidden-lg-up"/><h3>Bewerbung für</h3>
							<p>maximal {maximumNumberOfItemsInBasket} Wohnungen</p>
						</div>
						<ListWrapper component={SortableList}
						             axis={'y'}
						             className={classNames(style.list, style.stylizedList)}
						             itemClass={classNames(style.stylizedItem)}
						             movePositionInBasket={this.props.movePositionInBasket}
						             removeFromBasket={this.props.removeFromBasket}
						             shouldCancelStart={this.shouldCancelStart}
						             helperClass={style.stylizedHelper}
						             items={this.props.items}/>

						<div className="sortinfo">
						  {t('basket.sortinfo')}
						</div>
						<button onClick={this.applyOnline}
                    onTouchStart={this.applyOnline}
						        style={{float: 'right'}}
						        disabled={this.state.modal.isSubmitting}
						        className="btn btn-primary btn-sm">
							{t('residentialMarket.applyOnline')}
						</button>
					</div>

				<Modal
					isOpen={this.state.modal.isShown}
					onRequestClose={this.hideModal}
					contentLabel="Modal"
					style={CssUtility.getModalStyles()}
					appElement={document.getElementById('residentialMarket__container')}>

					<div className="modal-header" style={{border: 0}}>
						<button type="button" className="close" onClick={this.hideModal}>
							<span>&times;</span>
						</button>
					</div>

					<div className="modal-body">
					  <div>
					    <p>Bitte beachten Sie:</p>
					    <ul>
					      {
					        AblCh.isSpecailCallForApplication == false &&
					        <li>Sie können sich 1 Mal pro Monat bewerben.</li>
					      }
					      <li>Sie können pro Bewerbung bis zu {maximumNumberOfItemsInBasket} Wohnungen auswählen.</li>
					    </ul>
					    <p>Klicken Sie auf «Abbrechen», wenn Sie weitere Wohnungen hinzufügen möchten.<br/>
					      Klicken Sie auf «Online bewerben», wenn Ihre Auswahl vollständig ist.
					    </p>
					  </div>
					</div>
					<div className="modal-footer" style={{border: 0}}>
						<button type="button"
						        className="btn btn-secondary"
						        disabled={this.state.modal.isSubmitting}
						        onClick={this.hideModal}>{t('action.cancel')}
						</button>
						&nbsp;
						<button type="button"
						        className="btn btn-primary"
						        disabled={this.state.modal.isSubmitting}
						        onClick={this.redirect}>{t('residentialMarket.applyOnline')}
						</button>
					</div>
				</Modal>
			</div>
		)
	}
}
